import { COLOR_PALETTE } from 'constants/ui';

export const badgeContainerStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '2px 8px',
  backgroundColor: COLOR_PALETTE.BLUE[1],
  borderRadius: '4px',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
  border: `1px solid ${COLOR_PALETTE.BLUE[2]}`,

  '&:hover': {
    backgroundColor: COLOR_PALETTE.BLUE[2],
  },
};

export const iconStyles = {
  color: COLOR_PALETTE.BLUE[6],
  width: 14,
  height: 14,
};

export const textStyles = {
  color: COLOR_PALETTE.BLUE[7],
};

export const mutedBadgeContainerStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '2px 8px',
  backgroundColor: 'action.hover',
  borderRadius: '4px',
  border: '1px solid',
  borderColor: 'divider',
  cursor: 'default',
  verticalAlign: 'baseline',
};

export const mutedIconStyles = {
  color: 'text.secondary',
  width: 14,
  height: 14,
};

export const mutedTextStyles = {
  color: 'text.secondary',
};
